
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/validate/resetsuccess",
      function () {
        return require("private-next-pages/validate/resetsuccess/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/validate/resetsuccess"])
      });
    }
  